export const SHADE_FINDER_CONFIGURATION_UNDEFINED =
    "SHADE_FINDER_CONFIGURATION_UNDEFINED";

export const beautyFamilyCode = "V10";
